<template>
  <RevDrawer
    :back-button-label="i18n(translations.back)"
    :close-button-label="i18n(translations.cancel)"
    data-qa="fix-order-issue-drawer"
    :has-back-button="Boolean(currentIssueType)"
    :name="modalName"
    :title="modalTitle"
    @back="handleBack"
  >
    <template #body>
      <IssuesChoices
        v-if="!currentIssueType"
        :show-delivery-issue="props.order.state.code === 'SENT'"
        @select-issue="selectIssue"
      />

      <OutOfStockIssue
        v-if="currentIssueType === ISSUES.OUT_OF_STOCK"
        :order="props.order"
        @refresh-orders="props.refreshOrders"
      />

      <ContactCustomer
        v-if="
          hasCareAccess &&
          (currentIssueType === ISSUES.OTHER_ISSUE ||
            currentIssueType === ISSUES.DELIVERY_ISSUE)
        "
        :currentIssueType
        :order="props.order"
      />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { usePermissions } from '#imports'
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { PERMISSION_TYPES } from '~/constants/permissions'
import { ROUTE_NAMES } from '~/constants/routes'
import type { Order } from '~/scopes/orders/pages/components/Tab/Tab.types'

import { ISSUES, MODAL_NAME } from './FixOrderIssueDrawer.constants'
import translations from './FixOrderIssueDrawer.translations'
import type { ISSUE_TYPES } from './FixOrderIssueDrawer.types'
import ContactCustomer from './components/ContactCustomer/ContactCustomer.vue'
import IssuesChoices from './components/IssuesChoices/IssuesChoices.vue'
import OutOfStockIssue from './components/OutOfStockIssue/OutOfStockIssue.vue'

const props = defineProps<{
  order: Order
  refreshOrders: () => void
}>()

const i18n = useI18n()
const currentIssueType = ref<ISSUE_TYPES | ''>('')
const { hasRouteAccess } = usePermissions()
const modalName = computed(() => MODAL_NAME + props.order.id)

const modalTitle = computed(() => {
  const titles = {
    [ISSUES.OUT_OF_STOCK]: i18n(translations.outOfStockTitle),
    [ISSUES.DELIVERY_ISSUE]: i18n(translations.deliveryIssueTitle),
    [ISSUES.OTHER_ISSUE]: i18n(translations.otherIssueTitle),
  }

  return currentIssueType.value
    ? titles[currentIssueType.value]
    : i18n(translations.title)
})

const hasCareAccess = computed(() =>
  hasRouteAccess(
    {
      name: ROUTE_NAMES.CUSTOMER_CARE.CUSTOMER_REQUEST,
      // Fake customerRequestId param, required by hasRouteAccess to be able to resolve the route.
      params: { customerRequestId: '1234' },
    },
    PERMISSION_TYPES.EDIT,
  ),
)
function selectIssue(issueType: ISSUE_TYPES) {
  currentIssueType.value = issueType
}

function handleBack() {
  currentIssueType.value = ''
}
</script>
